import { watch } from 'vue';
import store from '@/store';

const hasAuth = (operates, code) => {
  const opts = operates ?? [];

  return opts.includes(code);
};

export const permissionDirective = {
  mounted(el, binding) {
    const { operates } = store.getters;

    let isShow = hasAuth(operates, binding.arg); // Get The Permission Check Function Binding Arg Can Be The Permission Id You Want To Check
    // Register A Listener That Triggers The Logic When Permissions Are Updated
    watch(
      () => store.getters?.operates, // Let S Say Permissions Are In The Component S Data Object
      val => {
        isShow = hasAuth(val, binding.arg);
        el.style.display = isShow ? '' : 'none';
      },
      { immediate: true }
    );
    el.style.display = isShow ? '' : 'none';
  },
  updated(el, binding) {
    const { operates } = store.getters;

    // The Same Logic Ensures That The Display State Of An Element Is Updated When The Permission State Changes
    const isShow = hasAuth(operates, binding.arg);

    el.style.display = isShow ? '' : 'none';
  }
};

export const isCompanyUserDirective = {
  mounted(el) {
    const { isCompanyUser } = store.getters;
    el.style.display = isCompanyUser ? '' : 'none';
  },
  updated(el) {
    const { isCompanyUser } = store.getters;
    el.style.display = isCompanyUser ? '' : 'none';
  }
};
